import { useTranslation } from "react-i18next";

import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";

import { ChecklistAnswer } from "../../BankruptcyChecklist.types";

interface Props {
  value: ChecklistAnswer;
  onChange: (value: ChecklistAnswer) => void;
  ariaLabel: string;
  yesLabel?: string;
  noLabel?: string;
}

const YES = "yes";
const NO = "no";

export function YesNoToggle({ value, onChange, ariaLabel, yesLabel, noLabel }: Props) {
  const { t } = useTranslation();

  const yesText = yesLabel ?? t("common.yes");
  const noText = noLabel ?? t("common.no");
  const selected = value === null ? null : value ? YES : NO;

  return (
    <Box
      display={"flex"}
      justifyContent={"flex-end"}
      bgcolor={(theme) => theme.palette.fsw["blue-5"]}
      border="1px solid"
      borderTop="none"
      borderColor={(theme) => theme.palette.fsw["blue-10"]}
      borderRadius={"4px"}
    >
      <ToggleButtonGroup
        exclusive
        color="primary"
        size="small"
        value={selected}
        aria-label={ariaLabel}
        onChange={(_event, next: string | null) => {
          if (next === null) {
            onChange(null);
            return;
          }
          onChange(next === YES);
        }}
        sx={{
          "& .MuiToggleButton-root.Mui-selected": {
            border: "none",
            backgroundColor: "primary.main",
            color: "primary.contrastText",
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          },
        }}
      >
        <ToggleButton value={YES} aria-label={yesText} sx={{ minWidth: 70 }}>
          {yesText}
        </ToggleButton>
        <ToggleButton value={NO} aria-label={noText} sx={{ minWidth: 70 }}>
          {noText}
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}
